import { Directive, HostListener, Injectable, OnDestroy, OnInit } from "@angular/core";
import { AuthService } from "app/configuration/auth/auth.service";
import { environment } from "environments/environment";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { filter, Subscription } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";
import { UtilsService } from "@core/services/utils/utils.service";

@Directive({ selector: "[KeysBlock]" })
export class KeysBlockDirective implements OnInit, OnDestroy {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _mStorage: manageStorageService,
    private _authService: AuthService,
    private _router: Router,
    private _utilS: UtilsService
  ) {
    history.pushState(null, '', window.location.href);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {


    if (environment.keyBlock  ) {
      if (event.key === 'F5' ||
        ((event.ctrlKey || event.metaKey) && event.key === 'r')) {
        event.stopImmediatePropagation();
        event.preventDefault(); // Prevent the default browser refresh
        this.showReloadWarning();
        return false;
      }
    }
    return true;
  }


  /**
  * The [beforeunload] event fires when a window is about to unload its resources
  * The [unload] event fires when the window is unloading its content and resources.
  * @param $event
  */
  @HostListener('window:beforeunload')
  bfUnload() {
    if (environment.destroyOnReload && !this._utilS.isSafari()) {
      this.unloadHandler().then(() => { });
    }
  }

  @HostListener('window:unload', ['$event'])
  unload() {
    if (environment.destroyOnReload && !this._utilS.isSafari()) {
      this.unloadHandler().then(() => { });
    }
  }

  async unloadHandler() {
    this._authService.signOut();
    this._mStorage.clearStorage("all");
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  public subscriber: Subscription;

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  ngOnInit(): void {

    /*In ngOnInit, I subscribe to the events router, which is the one that will send you the events every
    * time the navigation starts, and we filter it so that it only sends you when the navigation finishes NavigationEnd */
    if (environment.keyBlock) {
      this.subscriber = this._router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event) => {
        history.pushState(null, '');
      });
      window.addEventListener('popstate', this.onPopState); // Listen for popstate events (browser back/forward button clicks)
    }
  }

  ngOnDestroy() {
    /*In the onDestroy, I validate if my subscriber is still active and unsubscribe,
     if not it will remain active listening when you navigate to another component where you do not require it.*/
    this.subscriber?.unsubscribe();
    window.removeEventListener('popstate', this.onPopState);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private onPopState(event: PopStateEvent): void {
    history.pushState(null, ''); // Re-push null state to prevent actual back navigation
  }

  private showReloadWarning(): void {
    const currentPath = this._router.url;

    if (currentPath !== '/login' ||  !currentPath.includes('/login')) {
      const confirmed = confirm('Si recargas la página, perderás los datos de tu sesión actual que no hayan sido procesados. ¿Desea continuar?');
      if (confirmed) {
        window.location.reload();
      }
    }

  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

}